module.exports = __webpack_public_path__ + "static/media/transactionsIcon.6d5b4068.png";